import { Type } from "class-transformer";
import { EnaioObjectId } from "./EnaioObjectId";

export class EnaioAssignment {
    //netgen start
    @Type(() => EnaioObjectId)
    field: EnaioObjectId;
    value: any;
    //netgen end

    constructor(field: EnaioObjectId, value: any) {
        this.field = field;
        this.value = value;
    }


}
